.tableGrid {
  display: grid;
  gap: 4px;
  align-items: center;
  flex: 1;
  padding: 0 12px;
  @include themify($themes) {
    color: themed("main-primary");
  }
}

.table {
  overflow: hidden;
  position: relative;
  margin-top: 16px;
  height: 100%;
  border-radius: 12px 12px 0 0;

  @include themify($themes) {
    background-color: themed("main-secondary");
    border: solid 1px themed("neutral-secondary");
  }
  display: flex;
  flex-direction: column;
}

.tableDataWrapper {
  height: 100%;
  overflow: auto;
  min-height: 100px;
  position: relative;
}

.multipleItemsActionBar {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;

  @include themify($themes) {
    background-color: themed("btn-primary");
    color: themed("btn-primary-text");
  }

  .multipleItemsActionBarLeft {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .selectActionPlaceholder {
    @include themify($themes) {
      color: themed("btn-primary-text");
    }
  }
  
  .multipleItemsActionSelectMenu {
    right: 0;
  }

  .multipleItemsActionSelect {
    svg {
      transition: all 0.2s;
      @include themify($themes) {
        color: themed("btn-primary-text") !important;
      }
    }
  }
}

.stickyHeaderBackground {
  min-width: fit-content;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
  @include themify($themes) {
    background-color: themed("main-secondary");
  }
}

.expandedRow {
  padding: 12px 16px 16px 40px;
  border-bottom: 1px solid;
  @include themify($themes) {
    border-color: themed("neutral-secondary");
    background-color: themed("main-secondary");
  }
}

.tableHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
